<template>
    <div class="n-pb-4">
        <div class="c-banner c-banner-small n-col-1 n-border-box n-overflow-hidden"
             style="height: 200px;">
            <NImage class="c-banner-image n-col-1 n-h-1"
                    type="cover"
                    :src="require('@/assets/image/banner.jpg')">
            </NImage>

            <div class="c-banner-text n-col-1 c-max-width-2">
                <h1 class="n-c-1 n-text-center n-m-auto n-mb-1 c-f-1 n-f-1">
                    {{ LAN.news.searchForANN }}
                </h1>

                <div>
                    <a-input-search v-model:value="keyword"
                                    enter-button
                                    allowClear
                                    size="large"
                                    @search="searchData"
                                    :placeholder="LAN.nui.common.pleaseEnterKeyword" />
                </div>
            </div>
        </div>

        <div class="c-max-width n-m-auto n-mt-3 n-plr-2">
            <a-row :gutter="[20, 0]"
                   class="n-flex-a-s">
                <a-col :span="24"
                       :lg="4"
                       style="padding: 0">
                    <div id="menu"
                         os="0"
                         class="n-bg-1">
                        <div class="n-plr-4 n-pt-3">
                            <a-button type="primary"
                                      size="large"
                                      class="n-mr-6 category-button n-flex-s"
                                      @click="showMenu = !showMnenu">
                                <template #icon>
                                    <MenuUnfoldOutlined />
                                </template>
                            </a-button>
                            <h2 class="n-f-bold n-c-base c-title-1 n-b-line n-t-line n-inline-block n-pb-1">
                                {{ LAN.news.datePublished }}
                            </h2>
                        </div>
                        <div class="left-menu">
                            <div class="n-plr-4">
                                <ul class="n-p-0 n-ul n-m-0 n-pb-2 c-content-left">
                                    <li class="n-f-6 n-pointer c-hover n-b-line"
                                        v-for="item in [3,6,12,24]"
                                        :class="{ 'n-c-4 n-selected': type == item }"
                                        :key="item">
                                        <a href="javascript:;"
                                           class="c-tab-link n-c-4 n-block c-tab-link-event c-hover-target n-ptb-1 n-plr-2"
                                           @click="changeType(item)">{{LAN.news.lastMonth.replace('=MONTH=', item)}}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </a-col>
                <a-col :span="24"
                       :lg="20">
                    <div class="n-h-1 n-p-3">
                        <div class="n-flex n-flex-j-sb n-flex-a-c n-b-line n-mb-4 n-pb-4">
                            <span class="n-f-4 n-c-2">{{ LAN.news.res.replace('=COUNT=', this.pageInfo.total) }}</span>

                            <div class="n-flex n-flex-a-c">
                                <span class="n-inline-block n-mr-2">{{ LAN.news.sortBy }}</span>
                                <a-select :defaultValue="sort"
                                          style="width: 150px"
                                          @change="sortChange">
                                    <a-select-option value="desc">
                                        Descending
                                    </a-select-option>
                                    <a-select-option value="asc">
                                        Ascending
                                    </a-select-option>
                                </a-select>
                            </div>
                        </div>

                        <div v-if="loading"
                             class="n-h-1 n-bg-1 n-p-3">
                            <div class="thumb n-flex-s n-mr-3 n-mb-3 n-skeleton"></div>
                            <div class="n-skeleton n-skeleton-text n-ptb-4 n-col-2"></div>
                            <div class="n-skeleton n-skeleton-text n-ptb-4 n-mt-3"></div>
                            <div class="n-skeleton n-skeleton-text n-ptb-4 n-mt-3"></div>
                        </div>

                        <div v-else-if="data?.length > 0">
                            <ul class="n-ul n-p-0 news-list">
                                <li class="n-bg-1 n-radius-6 c-shadow n-pointer n-mb-4"
                                    v-for="item in data"
                                    :key="item.id">
                                    <router-link :to="{name: 'newsDetail', query: {id: item.id}}"
                                                 target="_blank"
                                                 class="n-flex n-ptb-4 c-tab-link c-tab-link-event n-col-1">
                                        <div class="n-plr-6 n-border-box n-flex-g n-flex-g-w-1-hack n-flex n-flex-dr-c n-flex-a-s n-flex-j-c n-col-1">
                                            <h4 class="n-f-6 n-c-4 n-f-bold n-m-0 n-col-1"
                                                v-html="item.title"></h4>
                                            <h4 class="n-c-4 n-e-2 n-m-0 n-col-1 n-mt-3"
                                                v-if="item.fAbstract"
                                                v-html="item.fAbstract"></h4>
                                        </div>

                                        <div class="news-list-right n-flex-s">
                                            <h4 class="n-c-4 n-text-center n-m-0">{{ LAN.news.publishDate }}</h4>
                                            <h5 class="n-c-4 n-f-bold n-text-center n-m-0">{{item.publishDate}}</h5>
                                        </div>
                                    </router-link>
                                </li>
                            </ul>

                            <a-pagination v-model:current="pageInfo.current"
                                          v-model:pageSize="pageInfo.size"
                                          show-quick-jumper
                                          show-size-changer
                                          :total="pageInfo.total"
                                          @change="onPageChange" />
                        </div>

                        <a-row :gutter="[15,15]"
                               class="n-col-1"
                               v-else>
                            <a-col class="n-bg-1 n-ptb-3"
                                   span="24">
                                <a-empty :description="LAN.news.noNews"></a-empty>
                            </a-col>
                        </a-row>
                    </div>
                </a-col>
            </a-row>
        </div>
    </div>

    <a-drawer v-model:visible="showMenu"
              placement="left"
              width="70%">
        <ul class="n-p-0 n-ul n-m-0">
            <li class="n-f-6 n-pt-1 n-pb-2 n-pointer c-hover n-b-line"
                v-for="item in [3,6,12,24]"
                :class="{ 'n-c-4 n-selected': type == item }"
                :key="item">
                <a href="javascript:;"
                   class="c-tab-link n-c-4 n-block c-tab-link-event n-ptb-1 n-plr-2"
                   @click="changeType(item)">{{LAN.news.lastMonth.replace('=MONTH=', item)}}</a>
            </li>
        </ul>
    </a-drawer>
</template>
<script>
    import { mapMutations, mapState } from "vuex";

    import {
        MenuUnfoldOutlined,
    } from "@ant-design/icons-vue";
    import NImage from "@/components/nui/NImage/NImage.vue";
    import Breadcrumb from "@/components/Breadcrumb.vue";
    import NEditorParserLocal from "@/components/NEditorParserLocal.vue";
    import nui from "@/assets/script";
    import LAN from "@/assets/script/LAN";

    export default {
        name: "News",
        computed: {
            ...mapState(nui.extendVue.extendState.concat([])),
        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
                loading: false,
                keyword: '',
                type: 3,
                showMenu: false,
                pageInfo: {
                    total: 0,
                    current: 1,
                    size: 10
                },
                sort: 'desc',
                data: []
            });
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat()),
            NActivated () {
            },
            NMounted () {
                this.loadData()
            },
            sortChange (res) {
                this.sort = res

                this.searchData()
            },
            async changeType (type) {
                this.type = type
                this.pageInfo = {
                    total: 0,
                    current: 1,
                    size: 10
                }

                await this.loadData();
            },
            async onPageChange () {
                await this.loadData();
            },
            async searchData () {
                this.pageInfo = {
                    total: 0,
                    current: 1,
                    size: 10
                }

                await this.loadData();
            },
            loadData () {
                this.loading = true;

                return this.request(this.API.searchCMSData, {
                    requestId: "searchCMSData",
                    params: {
                        current: this.pageInfo.current,
                        size: this.pageInfo.size,
                        keyword: this.keyword,
                        datePublishedLastMonth: this.type,
                        sortBy: this.sort
                    },
                }).then((res) => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.data = res.data.records
                        this.pageInfo.total = res.data.total
                    }

                    this.loading = false;
                    this.$nextTick(() => {
                        this.parseMathJax();
                    });
                });
            },
        }),
        components: {
            MenuUnfoldOutlined,
            NEditorParserLocal,
            NImage,
            Breadcrumb
        },
        ...nui.extendVue.extendLife,
    };
</script>
<style lang="scss" scoped>
    .category-button {
        display: none;
    }

    .c-title-1 {
        display: block;

        &:before {
            width: 90%;
        }

        &:after {
            width: 100%;
        }
    }

    @media screen and (max-width: 1100px) {
        .left-menu {
            display: none;
        }

        .c-title {
            display: none;
        }

        .category-button {
            display: inline-block;
        }
    }
</style>
